import { createResource, defaultHeaders } from "redux-rest-resource";
import { getAuthData, setAuthHeader } from "../../helpers/authStorage";
import { API_URL } from "../../constants/config";

const updateReduce = (state, { context, status }) => {
  if (state?.item && status === "resolved") {
    return {
      ...state,
      item: {
        ...state.item,
        items: state.item.items.map((item) =>
          item.ticketId === context.ticketId ? { ...item, status: context.status } : item,
        ),
      },
    };
  } else return { ...state };
};

const updateTicketStateReduce = (state, { context, status }) => {
  if (state?.item && status === "resolved") {
    return {
      ...state,
      item: {
        ...state.item,
        items: state.item.items.map((item) =>
          item.ticketId === context.ticketId ? { ...item, ...context.ticket } : item,
        ),
      },
    };
  } else return { ...state };
};

export const { types, actions, rootReducer } = createResource({
  name: "retailerTicket",
  actions: {
    get: {
      method: "GET",
      url: `${API_URL}/retailer/ticket/tickets`,
    },
    create: {
      method: "POST",
      url: `${API_URL}/retailer/ticket`,
    },

    update: {
      method: "PUT",
      url: `${API_URL}/retailer/ticket`,
      reduce: updateReduce,
    },

    sendMessage: {
      method: "POST",
      url: `${API_URL}/retailer/ticket/message`,
    },

    getMessages: {
      method: "GET",
      url: `${API_URL}/retailer/ticket/messages`,
    },

    // pure actions
    updateTicketState: {
      isPure: true,
      reduce: updateTicketStateReduce,
    },
  },
});

setAuthHeader(getAuthData().accessToken, defaultHeaders);
